import styled from "styled-components";
const SectionHeading = styled.h2 `
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 8px;
`;
export default SectionHeading;
